export enum APP_ERRORS {
  TOPIC_OT_FOUND = 'topicNotFound',
  NOT_LOGGED_IN = 'notLoggedIn',
  ORIGIN_NOT_ALLOWED = 'originNotAllowed',
  INTERNAL_SERVER_ERROR = 'internalServerError',
}

export default class AppError extends Error {
  constructor(message: APP_ERRORS) {
    super(message)
    this.name = 'AppError'
  }
}
